


















import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ICopyLinkedValueBehavior } from "../../../../../../../documaker/domain/format/objects";

@Component
export default class CopyLinkedTextsSelector extends Mixins() {

  @Prop({ default: () => [] as ICopyLinkedValueBehavior[] })
  items: ICopyLinkedValueBehavior[];

  $refs!: {
    table: ElTable,
  };

  @Watch("items")
  onItemsUpdated(newValue: ICopyLinkedValueBehavior[], oldValue: ICopyLinkedValueBehavior[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  currentChange(value: ICopyLinkedValueBehavior): void {}
}
